module.exports = __webpack_public_path__ + "3678d55bcce5dc1e20904f7830cd28b0.svg";